import React, { useState } from 'react';
import { Card, Col, ListGroup } from 'react-bootstrap';
import PaymentForm from '../../components/Payments/PaymentForm';
import ProceedingItem from '../../components/Proceedings/ProceedingItem';

const Results = ({proceedings, jurisdiction}) => {
    //State local
    const [ selectedData, setSelectedData ] = useState({
        show: false,
        proceeding: null,
        paymentType: null
    });
    //Render
    return (
        <Col xs={12}>
            <Card>
                <Card.Header className="bg-light">
                    <strong>Resultados de la búsqueda: ({ `1` }) Expediente/s</strong>
                </Card.Header>
                <ListGroup variant="flush">
                    <ListGroup.Item variant="info">
                        Para generar una nueva <strong>boleta de pago</strong> simplemente ubique el <strong>expediente</strong>, al cuál se relacionará dicha orden, y presione el botón que se corresponda con el <strong>tipo de pago</strong> a realizar.
                    </ListGroup.Item>
                    {
                        proceedings ? (
                            <>
                            {
                                proceedings.map( proceeding => (
                                    <ProceedingItem
                                        key={`p${proceeding.procid}`}
                                        proceeding={proceeding}
                                        setData={setSelectedData}
                                    />
                                ))
                            }
                            
                            <PaymentForm
                                data={selectedData}
                                setData={setSelectedData}
                                jurisdiction={jurisdiction}
                            />
                            </>
                        ) : null
                    }
                
                </ListGroup>
            </Card>
        </Col>
    );
};

export default Results;